export { default } from 'features/menu/routes/menu-recent-items-route';
